import { render, staticRenderFns } from "./DeliverGoods.vue?vue&type=template&id=462cd575&scoped=true&"
import script from "./DeliverGoods.vue?vue&type=script&lang=js&"
export * from "./DeliverGoods.vue?vue&type=script&lang=js&"
import style0 from "./DeliverGoods.vue?vue&type=style&index=0&id=462cd575&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462cd575",
  null
  
)

export default component.exports